import type { ReactNode } from 'react';
import { IonIcon } from '@ionic/react';
import { lockClosed, lockOpen, personCircleOutline } from 'ionicons/icons';

interface LeagueHeaderCardProps {
  name: string;
  creatorName?: string | null;
  participantsCount: number;
  maxPlayers: number;
  isPublic: boolean;
  /** League image slot: read-only `LeagueImage` or the admin `LeagueImageEditor`. */
  avatar: ReactNode;
}

const statLabelClass = 'text-[10px] font-extrabold uppercase tracking-wide';
const statLabelStyle = { color: '#9fb2d4' };
const statValueStyle = { fontSize: '20px', fontWeight: 800 };

/** Navy header card at the top of Puntos, styled like the member team header. */
export const LeagueHeaderCard = ({
  name,
  creatorName,
  participantsCount,
  maxPlayers,
  isPublic,
  avatar,
}: LeagueHeaderCardProps) => (
  <div
    className="mb-4 p-4 text-white shadow-[0_8px_22px_rgba(12,32,80,0.18)]"
    style={{ background: 'linear-gradient(135deg, #0a2a5b, #1a3d70)', borderRadius: '16px' }}
  >
    <div className="flex items-center gap-3">
      {avatar}
      <div className="min-w-0 flex-1">
        <div className="truncate font-heading" style={{ fontSize: '18px', fontWeight: 800, lineHeight: 1.15 }}>
          {name}
        </div>
        {/* Same creator row as FantasyLeagueCard, recoloured for the navy background */}
        <div className="mt-1 flex items-center gap-1" style={{ color: '#b8c7e2' }}>
          <IonIcon icon={personCircleOutline} style={{ fontSize: '1rem', flexShrink: 0 }} />
          <span className="truncate text-sm font-semibold">{creatorName || 'Desconocido'}</span>
        </div>
      </div>
    </div>

    <div className="mt-3 flex items-stretch gap-3">
      <div className="flex-1">
        <div className={statLabelClass} style={statLabelStyle}>
          Participantes
        </div>
        <div className="font-heading" style={statValueStyle}>
          {participantsCount}/{maxPlayers}
        </div>
      </div>
      <div className="w-px self-stretch" style={{ background: 'rgba(255,255,255,0.15)' }} />
      <div className="flex-1">
        <div className={statLabelClass} style={statLabelStyle}>
          Liga
        </div>
        <div className="flex items-center gap-1.5 font-heading" style={statValueStyle}>
          <IonIcon
            icon={isPublic ? lockOpen : lockClosed}
            color={isPublic ? 'success' : 'warning'}
            style={{ fontSize: '1.1rem' }}
          />
          {isPublic ? 'Pública' : 'Privada'}
        </div>
      </div>
    </div>
  </div>
);
